import { Button, ButtonProps, IconButton, IconName } from '@optimus-web/core';
import { ToggleButtonComponentStyled } from './style';

export interface ToggleButtonProps extends Omit<ButtonProps, 'variant'> {
    compact?: boolean;
    checked?: boolean;
}

export const ToggleButton = ({ compact, checked, loading, ...other }: ToggleButtonProps) => (
    <ToggleButtonComponentStyled
        as={(compact ? IconButton : Button) as React.FC<ToggleButtonProps>}
        {...other}
        icon={IconName.Done}
        loading={loading}
        variant={checked ? 'success' : 'tertiary'}
    />
);
